module.exports = __webpack_public_path__ + "img/continents-small.c9550c2b.png";